<template>
  <el-container>
    <el-main>
      <el-form ref="form" label-width="80px">
        <h3>家庭地址</h3>
        <div v-for="(item, index) in address1" :key="'1_'+index">
          <el-divider content-position="left">家庭地址 {{index+1}}</el-divider>
          <el-form-item label="省市县/区">
            <el-cascader
                :value="item.value"
                :options="area"
                @change="cascaderChange($event, item, 'address1', index)"></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址">
            <el-input @change="change($event, item, 'address1', index)" v-model="item.remark"></el-input>
          </el-form-item>
        </div>
        <el-form-item >
          <el-button type="primary" icon="el-icon-plus" @click="add('address1', 1)">更多地址</el-button>
        </el-form-item>
        <h3>收件地址</h3>
        <div v-for="(item, index) in address2" :key="'2_'+index">
          <el-divider content-position="left">收件地址 {{index+1}}</el-divider>
          <el-form-item label="省市县/区">
            <el-cascader
                :value="item.value"
                :options="area"
                @change="cascaderChange($event, item, 'address2', index)"></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址">
            <el-input @change="change($event, item, 'address2', index)" v-model="item.remark"></el-input>
          </el-form-item>
        </div>
        <el-form-item >
          <el-button type="primary" icon="el-icon-plus" @click="add('address2', 2)">更多地址</el-button>
        </el-form-item>
        <h3>其他地址</h3>
        <div v-for="(item, index) in address3" :key="'3_'+index">
          <el-divider content-position="left">其他地址 {{index+1}}</el-divider>
          <el-form-item label="省市县/区">
            <el-cascader
                :value="item.value"
                :options="area"
                @change="cascaderChange($event, item, 'address3', index)"></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址">
            <el-input @change="change($event, item, 'address3', index)" v-model="item.remark"></el-input>
          </el-form-item>
        </div>
        <el-form-item >
          <el-button type="primary" icon="el-icon-plus" @click="add('address3', 3)">更多地址</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import $http from "../../../request.js";
import _ from "lodash";
export default {
  name: "infoAddress",
  created(){
    if (this.list) {
      this.address1 = [
        ...this.list.filter(v=>v.type==1),
        ...this.address1
      ].map(v=>{
        v.value = [String(v.province_id), String(v.city_id), String(v.county_id)];
        return v;
      });
      this.address2 = [
        ...this.list.filter(v=>v.type==2),
        ...this.address2
      ].map(v=>{
        v.value = [String(v.province_id), String(v.city_id), String(v.county_id)];
        return v;
      });
      this.address3 = [
        ...this.list.filter(v=>v.type==3),
        ...this.address3
      ].map(v=>{
        v.value = [String(v.province_id), String(v.city_id), String(v.county_id)];
        return v;
      });
    }
    
  },
  computed:{
    ...mapState([
      "defaultInfo",
      "area"
    ])
  },
  props:{
    list:{
      type: Array,
      default:function(){
        return [];
      }
    }
  },
  data(){
    return {
      address1:[],
      address2:[],
      address3:[],
      form:{}
    }
  },
  methods:{
    add(address, index){
      this[address] = [
        ...this[address],
        {
          value: [],
          type: index,
          province_id: '',
          city_id: '',
          county_id: '',
          remark: ''
        }
      ]
    },
    change(e, values, key, index){
      console.log(e);
      this.updateAddress(values, key, index);
    },
    cascaderChange(e, values, key, index) {
      values.province_id = e[0];
      values.city_id = e[1];
      values.county_id = e[2];
      this.updateAddress(values, key, index);
    },
    onSubmit() {},
    cancel() {
      this.$emit('cancel');
    },
    updateAddress(obj) {
      ///api/member/member_address/add
      const params = _.pick(obj, [
        "id",
        "type",
        "province_id",
        "city_id",
        "county_id",
        "remark"
      ]);
      let url = "/api/member/member_address/add";
      if(params.id) {
        url = "/api/member/member_address/edit";
      }
      $http.post(url, params)
        .then(res=>{
          if (res.data.code===1){
            this.$message({
              message: params.id?"修改地址成功":"新增地址成功",
              type: 'success'
            });
            this.$emit('success');
          }
        });
    }
  }
};
</script>

<style lang="less">
  
</style>

